export default __webpack_public_path__ + "static/media/mapa-local.913e7ea8.svg";